import { ReactNode, useEffect, useState } from "react";

export interface IModalProps {
    title: string;
    children: ReactNode;
    closeOnCoverClick?: boolean | undefined;
    onClose: () => void;
}


export default function Modal(props: IModalProps) {
    const [closeOnCoverClick, setCloseOnCoverClick] = useState<boolean>(true)

    useEffect(() => {
        if(props.closeOnCoverClick === undefined) {
            setCloseOnCoverClick(true);
        } else {
            setCloseOnCoverClick(props.closeOnCoverClick);
        }
    }, [props.closeOnCoverClick]);

    return (
        <>
            <div className="modal" onClick={(e) => {
                if(closeOnCoverClick && (e.target as any).className === 'modal-container') {
                    props.onClose();
                }
            }}>
                <div className="modal-container">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6>{props.title}</h6>
                            <button type="button" title="close" onClick={() => props.onClose()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M1 19L19 1M1 1L19 19" stroke="#01065B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg></button>
                        </div>
                        <div className="modal-body">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}